import jwtDecode from 'jwt-decode';
import { takeEvery, put, call, delay, select } from 'redux-saga/effects';
import * as userApi from '../../api/userApi';
import * as actions from '../actions';
import * as selectors from '../selectors';
import toast from 'react-hot-toast';
import { push } from 'connected-react-router';

export function* loginOauth({ payload: { accessToken } }) {
  try {
    yield put(actions.user.setLoading(true));
    const token = yield call(userApi.loginOauth, accessToken);
    const user = jwtDecode(token);
    user.isAdmin = Boolean(user.roles.find(role => role.name === 'admin'));
    localStorage.setItem('jwt', token);
    yield put(actions.user.loginSuccess(user, token));
    yield put(actions.user.hydrate());
    yield put(actions.user.redirectFromLogin());
  } catch (e) {
    yield put(actions.user.loginFail('Invalid login attempt'));
  } finally {
    yield put(actions.user.setLoading(false));
    yield put(actions.user.setAppLoaded(true));
  }
}
export function* login({ payload: { credentials } }) {
  try {
    yield put(actions.user.setLoading(true));
    const token = yield call(userApi.login, credentials);
    const user = jwtDecode(token);
    user.isAdmin = Boolean(user.roles.find(role => role.name === 'admin'));
    localStorage.setItem('jwt', token);
    yield put(actions.user.loginSuccess(user, token));
    yield put(actions.user.hydrate());
    yield put(actions.user.redirectFromLogin());
  } catch (e) {
    yield put(actions.user.loginFail('Invalid login attempt'));
  } finally {
    yield put(actions.user.setLoading(false));
    yield put(actions.user.setAppLoaded(true));
  }
}

export function* redirectFromLogin() {
  try {
    const path = yield select(selectors.getCurrentPath);
    if (['/login', '/path'].includes(path)) {
      yield put(push('/home'));
    }
  } catch (e) {
    yield put(actions.user.loginFail('Invalid login attempt'));
  }
}

export function* loginFromToken({ payload: { jwt } }) {
  try {
    const user = jwtDecode(jwt);
    user.isAdmin = Boolean(user.roles.find(role => role.name === 'admin'));
    yield put(actions.user.loginFromTokenSuccess(user, jwt));
    // yield put(actions.showcase.preloadShowcaseData());
    yield put(actions.admin.getAllTemplates());
    yield put(actions.admin.getUsers());
    yield put(actions.admin.getSites());
    yield put(actions.content.getSites());
    yield put(actions.user.hydrate());
    yield put(actions.user.redirectFromLogin());
  } catch (e) {
    yield put(actions.user.loginFromTokenFail(e.message));
    yield put(push('/home'));
  } finally {
    yield put(actions.user.setAppLoaded(true));
  }
}
export function* hydrate() {
  try {
    yield put(actions.admin.getAllTemplates());
    yield put(actions.admin.getUsers());
    yield put(actions.admin.getSites());
    yield put(actions.content.getAuthors());
    yield put(actions.content.getSites());
  } catch (e) {
    console.log(e);
  }
}

export function* updatePassword({ payload: { credentials } }) {
  try {
    yield call(userApi.updatePassword, credentials);
    yield put(actions.user.updatePasswordSuccess());
    toast.success('Password updated successfully.');
    yield put(actions.user.login({ username: credentials.email, password: credentials.password }));
    yield put(push('/'));
  } catch (e) {
    e && e.message && toast.error(e.message);
    yield put(actions.user.updatePasswordFail(e.message));
  }
}

export function* resetPassword({ payload: { email } }) {
  try {
    yield put(actions.user.setLoading(true));
    yield call(userApi.resetPassword, { email });
    yield put(actions.user.resetPasswordSuccess('Password reset email sent.'));
    toast.success('An email was sent to this account with instructions for resetting the password.');
    yield put(push('/'));
  } catch (e) {
    e && e.message && toast.error(e.message[0]);
    yield put(actions.user.resetPasswordFail(e.message));
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* logout() {
  try {
    yield put(actions.user.setLoading(true));
    yield localStorage.clear();
    yield delay(1 * 1000);
    yield put(push('/login'));
  } catch (e) {
    e && e.message && toast.error(e.message[0]);
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* navigate({ payload: { route } }) {
  try {
    yield put(push(route));
  } catch (e) {
    toast.error(e);
  }
}

export function* clearSeriesCache({
  payload: {
    location: { pathname },
  },
}) {
  try {
    if (!pathname?.includes('/series')) {
      yield put(actions.series.clearSeriesCache());
    }
  } catch (e) {
    console.log(e);
  }
}

export function* currentUserSagas() {
  yield takeEvery(actions.user.login, login);
  yield takeEvery(actions.user.loginOauth, loginOauth);
  yield takeEvery(actions.user.loginFromToken, loginFromToken);
  yield takeEvery(actions.user.updatePassword, updatePassword);
  yield takeEvery(actions.user.resetPassword, resetPassword);
  yield takeEvery(actions.user.logout, logout);
  yield takeEvery(actions.user.navigate, navigate);
  yield takeEvery(actions.user.redirectFromLogin, redirectFromLogin);
  yield takeEvery(actions.user.hydrate, hydrate);
  yield takeEvery('@@router/LOCATION_CHANGE', clearSeriesCache);
}
